import { Box, IconButton, Paper, Stack, Typography } from "@mui/material";
import HeaderImg from "../../../assets/images/header.svg";
import { getTimeOfDay } from "../../../helpers/common/utility";
import { connect } from "react-redux";
import Lotties from "../../Lotties";
import GroupLottie from "../../../assets/lottie/group.json";
import LogoImg from "../../../assets/images/logo_vertical.png";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft } from "@mui/icons-material";

const parseNama = (value: string) => {
  let txt = {
    title: "-",
    subtitle: "",
  };
  if (!value) return txt;
  let txt_split = value.split(" ");
  txt.title = txt_split[0];
  txt.subtitle = txt_split.slice(1).join(" ");

  return txt;
};

const TopNavBaru = (props: {
  state_antrian_detail: any;
  border?: boolean;
  state_user: any;
  is_logo?: boolean;
  is_back?: boolean;
}) => {
  const {
    state_antrian_detail,
    border = true,
    state_user,
    is_logo = true,
    is_back,
  } = props;
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      <Box
        sx={{
          backgroundImage: `url(${HeaderImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "30vh",
          width: "100%",
          borderRadius: border ? "0 0 24px 24px" : "",
          color: "#FFF !important",
          display: "flex",
          // alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Stack
          spacing={0}
          sx={{
            padding: "24px 32px",
          }}
        >
          {is_back && (
            <Paper
              sx={{
                borderRadius: "16px",
                border: "0 !important",
                width: "50px",
                height: "50px",
              }}
              elevation={0}
              variant="outlined"
            >
              <IconButton onClick={() => navigate(-1)}>
                <ChevronLeft fontSize="large"></ChevronLeft>
              </IconButton>
            </Paper>
          )}
          {is_logo && (
            <img
              src={LogoImg}
              alt="logo"
              style={{
                height: "50px",
                width: "50px",
                objectFit: "contain",
                filter: "brightness(0) invert(1)",
              }}
            />
          )}

          <Box height="12px"></Box>
          <Typography variant="subtitle1" fontWeight="300">
            Selamat {getTimeOfDay()},
          </Typography>
          <Typography variant="h4">
            {
              parseNama(
                state_antrian_detail
                  ? state_antrian_detail?.pasien.nama
                  : state_user?.nama
              ).title
            }
          </Typography>
          <Typography variant="body1" fontWeight="300">
            {
              parseNama(
                state_antrian_detail
                  ? state_antrian_detail?.pasien.nama
                  : state_user?.nama
              ).subtitle
            }
          </Typography>
        </Stack>
        <Box
          sx={{
            // backgroundColor: "#000",
            width: "70px",
            height: "70px !important",
            margin: "32px",
            borderRadius: "50%",
          }}
          onClick={() =>
            location.pathname !== "/profile" && navigate("/profile")
          }
          // onClick={() => navigate("/profile")}
        >
          <Lotties file={GroupLottie} height="70px" width="70px" loop={true} />
        </Box>
      </Box>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    state_antrian_detail: state.antrian.detail,
    state_user: state.auth.user,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TopNavBaru);
